import React, { ReactNode } from 'react'
import { InterviewRootFallback } from './interview-fallback.ui'
import { InterviewRouter } from './interview-router.ui'
import { InterviewRouterProps } from './interview-ui.types'

export function Interview(): ReactNode {
  // инкапсулируем в фолбеках логику получения всех необходимых данных
  // и используем рендер проп чтобы зарендерить саму бизнес логику
  return (
    <InterviewRootFallback>
      {(props: InterviewRouterProps) => <InterviewRouter {...props} />}
    </InterviewRootFallback>
  )
}
